import type { TranslationTag } from '@ps/web-shared-components';
import { Translation } from '@ps/web-shared-components';
import React from 'react';

import { TXTCLI_No_games_currently_match_your__ELL } from './TableEmptyMessage.messages.json';
import styles from './TableEmptyMessage.scss';

interface Props {
  tag?: TranslationTag;
}

const TableEmptyMessage: React.FC<Props> = ({
  tag = TXTCLI_No_games_currently_match_your__ELL
}) => (
  <pre className={styles.root}>
    <Translation {...tag} />
  </pre>
);

export default TableEmptyMessage;
